var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Inserir novo")]),_c('div',{staticClass:"container"},[_c('FormStates',{attrs:{"enviar":_vm.enviar,"estado":_vm.estado,"show":_vm.show,"saving":_vm.saving,"isReadOnly":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }